<template>
  <div id="home" class="pos_container_panel">
    <el-form :model="searchForm" label-width="110px" :inline="true">
      <el-row>
        <el-form-item :label="$t('INCIDENTREPORTINFO.Client')">
          <el-input
            @focus="showClientNamePop"
            readonly
            v-model="searchForm.customerName"
            class="myinput_inner"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('INCIDENTREPORTINFO.Traveler')">
          <el-input
            v-model="searchForm.guestName"
            class="myinput_inner"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('INCIDENTREPORTINFO.Phone')">
          <div class="div_grid">
            <el-select v-model="searchForm.peopleType">
              <el-option
                v-for="item in phoneOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              v-model="searchForm.mobile"
              class="myinput_inner"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button class="search-btn" @click="searchClick">{{
            $t("HOME.BUTTONSEARCH")
          }}</el-button>
        </el-form-item>
        <el-form-item>
          <a href="javascript:void(0);" @click="showMore">{{
            $t("INCIDENTREPORTINFO.AdvancedSearch")
          }}</a>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item :label="$t('INCIDENTREPORTINFO.CITY')">
          <destination
            class="myinput_inner"
            :returnParentValue="searchForm.cityName"
            :defaultSearchValue="searchForm.cityName"
            @returnCityInfo="setDestination"
            :isHotCity="false"
            :key="destinationKey"
          ></destination>
        </el-form-item>
        <el-form-item :label="$t('INCIDENTREPORTINFO.ChooseDate')">
          <div class="div_grid" style="grid-template-columns: 0.3fr 0.7fr">
            <el-select v-model="searchForm.dateTimeType">
              <el-option
                v-for="item in datetypeoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-date-picker
              v-model="searchForm.dateTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('MANUALORDERHOTEL.COUNTRYNAME')">
          <el-select v-model="searchForm.countryCode" placeholder="请选择" filterable>
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in nationoption"
              :key="item.countryCode"
              :label="item.countryNameLists['zh-CN']"
              :value="item.countryCode"
            >
            </el-option>
          </el-select>

          
        </el-form-item>
      </el-row>
    </el-form>
    <el-form
      :model="searchForm"
      label-width="110px"
      :inline="true"
      v-if="showMoreDialog"
    >
      <el-form-item :label="$t('INCIDENTREPORTINFO.HotelName')">
        <el-input
          v-model="searchForm.hotelName"
          class="myinput_inner"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('INCIDENTREPORTINFO.OrderNo')">
        <el-input
          v-model="searchForm.bookingCode"
          class="myinput_inner"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('INCIDENTREPORTINFO.OrderStatus')">
        <el-select
          v-model="searchForm.orderStatus"
          multiple
          placeholder="请选择"
        >
          <el-option
            v-for="item in orderstatusoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('INCIDENTREPORTINFO.PaymentType')">
        <el-select v-model="searchForm.paymentType" placeholder="请选择">
          <el-option
            v-for="item in paymentoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('INCIDENTREPORTINFO.VendorOrderNo')">
        <el-input
          v-model="searchForm.sourceBookingId"
          class="myinput_inner"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('INCIDENTREPORTINFO.HotelType')">
        <el-select v-model="searchForm.hotelType" placeholder="请选择">
          <el-option
            v-for="item in hotelTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('INCIDENTREPORTINFO.BurhotelConfirmNo')">
        <el-input
          v-model="searchForm.hotelConfirmationNo"
          class="myinput_inner"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('INCIDENTREPORTINFO.BookingSource')">
        <el-select
          v-model="searchForm.bookingChannel"
          multiple
          placeholder="请选择"
        >
          <el-option
            v-for="item in BookingSourceOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('INCIDENTREPORTINFO.Vendor')">
        <el-select v-model="searchForm.source" multiple placeholder="请选择">
          <el-option
            v-for="item in vendorOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('INCIDENTREPORTINFO.DomesticOrInternational')">
        <el-select v-model="searchForm.isInternational" placeholder="请选择">
          <el-option
            v-for="item in domesticOrInternationalOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <!--Table          -->
    <div class="div_main_table">
      <Loading :loading="orderloading" :isRelativeBrowserWin="false" />
      <el-main style="padding-top: 0; padding-bottom: 0">
        <el-button
          style="margin-top: 1rem"
          @click="clickExport"
          type="primary"
          >{{ $t("ORDERLIST.EAPORTEXCEL") }}</el-button
        >
        <el-table
          :data="tableData"
          class=""
          :empty-text="$t('ORDERLIST.NoData')"
          width="100%"
        >
          <el-table-column
            prop="customerName"
            label="Client"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column label="BookingDate" align="center">
           <template #default="{ row }">
              <span>{{ formatDateTime(row.creationDate, "YYYY/MM/DD") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="hotelName"
            label="Hotel Name"
            min-width="100"
            align="center"
          >
            <template #default="{ row }">
              <span>{{ showHotelName(row.hotelName) }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="checkInDate" label="Check-in" align="center">
            <template #default="{ row }">
              <span>{{ formatDateTime(row.checkInDate, "YYYY/MM/DD") }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="checkOutDate" label="Check-out" align="center">
            <template #default="{ row }">
              <span>{{ formatDateTime(row.checkOutDate, "YYYY/MM/DD") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="guestNames"
            label="PassengerName"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sourceBookingId"
            label="PNR"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="agentPhone"
            label="Contact Number"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="agentEmail"
            label="Contact Email"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="mI1"
            label="组织机构1"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="mI2"
            label="组织机构2"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="mI3"
            label="组织机构3"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="mI4"
            label="组织机构4"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="mI5"
            label="组织机构5"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="mI6"
            label="组织机构6"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="mI7"
            label="组织机构7"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="mI8"
            label="组织机构8"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="bookingId"
            label="TicketNum"
            fixed="right"
            width="110"
          ></el-table-column>
        </el-table>
      </el-main>
      <el-footer style="margin: 1rem 2rem; background-color: #ffffff">
        <el-pagination
          style="float: right; margin: 1rem 0"
          background
          layout="total,prev, pager, next"
          :page-size="15"
          @current-change="handleCurrentChange"
          :total="totalCount"
          v-model:current-page="Pageone"
          :key="destinationKey"
        >
        </el-pagination>
      </el-footer>
    </div>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <ClientList
      :customerDialogVisible="clientListFlag"
      @setCustomerFlag="setCustomerFlag"
      @customerInfo="selectClient"
    ></ClientList>
  </div>
</template>
  
  <script>
import {
  getIncidentList,
  incidentDownLoadExcel,
  incidentpreDownLoadExcel,
} from "../../api/bookingData.js";
import { getcountryList } from "@/api/shoppingData";
import Destination from "../../components/Destination.vue";
import { formatDateTime, getFileName, hideElement } from "@/utils/utils.js";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import Loading from "@/components/Loading.vue";
import ClientList from "@/components/ClientList.vue";

export default {
  name: "IncidentReport",
  components: {
    Destination,
    ConfirmBoxs,
    Loading,
    ClientList,
  },
  data() {
    return {
      orderloading: false,
      clientListFlag: false,
      confirmIcon: "",
      confirmFlag: false,
      confirmMsg: "",
      paymentType: {
        0: "OPTIONS.PAYMENTSTATUSAll", //全部
        1: "OPTIONS.PAYMENTSTATUSHotel", //到店付
        2: "OPTIONS.PAYMENTSTATUSpre", //预付
        3: "OPTIONS.PAYMENTSTATUSPublic", //公付
      },
      orderStatus: {
        BOOKED: "OPTIONS.OrderSUCCESS",
        CANCELLED: "OPTIONS.OrderCancel",
        CHECKOUT: "OPTIONS.OrderLeave",
        NOSHOW: "OPTIONS.OrderPaymentStatus",
        PENDING_CONFIRMATION: "OPTIONS.OrderPendingStatus",
        PENDING_BOOKING: "OPTIONS.PENDINGBOOKING",
        CWT_PENDING_CONFIRMATION: "OPTIONS.PENDINPROCESSED",
        CWT_PENDING_CANCELLATION: "OPTIONS.PENDINGCANCEL",
        BOOKING_FAILED: "预订失败",
      },
      destinationKey: 0, //监控选择城市子组件
      showMoreDialog: false,
      phoneOptions: [
        { value: "0", label: "全部" },
        { value: "1", label: "入住人" },
        { value: "2", label: "预订人" },
      ],
      hotelTypeOptions: [
        { value: "", label: "全部" },
        { value: "1", label: "公司协议" },
        { value: "2", label: "CWT协议" },
        { value: "0", label: "非协议" },
      ],
      BookingSourceOptions: [
        { value: "0", label: "OBT_H5" },
        { value: "1", label: "OBT" },
        { value: "2", label: "CRM代客下单" },
        { value: "3", label: "CRM补录订单" },
        { value: "4", label: "公众号(H5)" },
        { value: "5", label: "客户对接" },
      ],
      vendorOptions: [
        { value: "Sabre", label: "Sabre" },
        { value: "Sabre-Oversea", label: "Sabre-Oversea" },
        { value: "Elong", label: "Elong" },
        { value: "FuXun", label: "FuXun" },
        { value: "Booking", label: "Booking" },
        { value: "Booking-Oversea", label: "Booking-Oversea" },
        { value: "CWTbur", label: "CWTbur" },
        { value: "OBT", label: "OBT" },
        { value: "dongcheng", label: "dongcheng" },
        { value: "huazhu", label: "huazhu" },
        { value: "atour", label: "atour" },
        { value: "homeinns", label: "homeinns" },
        { value: "wehotel", label: "wehotel" },
      ],
      domesticOrInternationalOptions: [
        { value: "0", label: "全部" },
        { value: "2", label: "国际" },
        { value: "1", label: "国内" },
      ],
      searchForm: {
        customerCode: "",
        customerName: "",
        guestName: "", //入住人
        peopleType: "0", //手机号选择类型
        mobile: "", //手机号
        cityCode: "", //入住城市
        city: {},
        dateTimeType: "bookingDate", //时间类型
        hotelName: "", //酒店名称
        bookingCode: "", //订单号
        orderStatus: "", //订单状态
        paymentType: "0", //支付方式
        sourceBookingId: "", //供应商订单号
        hotelConfirmationNo: "", //酒店确认号
        hotelType: "", //酒店类型
        bookingChannel: "", //预定来源
        source: "", //供应商
        isInternational: "0", //国内国际
        countryCode: "", //国家代码
        dateTime: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 7),
          new Date(),
        ],
        pageNum: 1,
        pageLimit: "",
      },
      totalCount: 0,
      Pageone: 1,
      tableData: [],
      nationoption: [],
    };
  },
  computed: {
    paymentoptions: function () {
      let result = [];
      for (let key in this.paymentType) {
        let item = {};
        item.value = key;
        item.label = this.$t(this.paymentType[key]);
        result.push(item);
      }
      return result;
    },
    datetypeoptions: function () {
      var result = [
        { label: this.$t("ORDERLIST.BookingDate"), value: "bookingDate" },
        { label: this.$t("ORDERLIST.CheckInDate"), value: "checkInDate" },
      ];
      return result;
    },
    orderstatusoptions: function () {
      let result = [];
      for (let key in this.orderStatus) {
        let item = {};
        item.value = key;
        item.label = this.$t("COMMONPARAM.ORDERSTATE." + key);
        result.push(item);
      }
      return result;
    },
    showHotelName() {
      return function (hotelName) {
        if (hotelName["en"] != "") {
          return hotelName["en"];
        }
        return hotelName["zh-CN"];
      };
    },
  },
  mounted() {
    //this.getCustomerList(1);
    //-- CRM、OBT跳转处理 --
    //判断来源 CRM、OBT跳转过来隐藏部分元素
    hideElement(this);
    this.getCountryList();
  },
  methods: {
    formatDateTime,
    //excel 导出
    async clickExport() {
      // bookingDate - 预订创建日期，checkInDate - 入住日期
      //请求接口
      let downParam = {
        customerCode: this.searchForm.customerCode,
        customerName: this.searchForm.customerName,
        guestNames: this.searchForm.guestName,
        cityCode: this.searchForm.cityCode,
        checkInDate: this.searchForm.dateTime
          ? formatDateTime(this.searchForm.dateTime[0], "YYYY-MM-DD")
          : null,
        checkOutDate: this.searchForm.dateTime
          ? formatDateTime(this.searchForm.dateTime[1], "YYYY-MM-DD")
          : null,
        hotelName: this.searchForm.hotelName,
        bookingId: this.searchForm.bookingCode.trim(),
        bookingStatus:
          this.searchForm.orderStatus != ""
            ? this.searchForm.orderStatus.join()
            : "",
        chooseDate: this.searchForm.dateTimeType,
        paymentType: parseInt(this.searchForm.paymentType),
        isInternational: this.searchForm.isInternational
          ? parseInt(this.searchForm.isInternational)
          : 0,
        PeopleType: this.searchForm.peopleType
          ? parseInt(this.searchForm.peopleType)
          : 0,
        Mobile: this.searchForm.mobile,
        hotelType:
          this.searchForm.hotelType != ""
            ? parseInt(this.searchForm.hotelType)
            : null,
        hotelConfirmationNo: this.searchForm.hotelConfirmationNo,
        bookingChannel:
          this.searchForm.bookingChannel !== ""
            ? this.searchForm.bookingChannel.join()
            : null,
        source:
          this.searchForm.source !== "" ? this.searchForm.source.join() : null,
        countryCode: this.searchForm.countryCode,
      };
      this.orderloading = true;
      await incidentpreDownLoadExcel(downParam)
        .then((preRes) => {
          this.orderloading = false;
          if (preRes.code == 200) {
            if (preRes.data.error.code == 0) {
              //开始下载
              this.$message(this.$t("MESSAGE.DOWNLOADSTART"));
              incidentDownLoadExcel(downParam)
                .then((res) => {
                  // 执行下载
                  const downloadLink = document.createElement("a");
                  // 设置下载文件名
                  const fileName = String(getFileName() || "incident").replace(/[^a-zA-Z0-9_-]/g, "");
                  // .csv 文件后缀
                  downloadLink.download = (fileName || "incident") + ".csv"; // 文件名称
                  downloadLink.style.display = "none";
                  //csv文件的type  text/csv    xls:application/vnd.ms-excel
                  const blob = new Blob([res], { type: "text/csv" }); //字节转成 Blob
                  const downloadUrl = URL.createObjectURL(blob);
                  downloadLink.href = downloadUrl;
                  downloadLink.click();
                  setTimeout(() => URL.revokeObjectURL(downloadUrl), 0);
                })
                .catch((error) => {
                  console.log("导出Excel", error);
                });
            } else {
              this.confirmFlag = true;
              this.confirmMsg =
                this.$t("ERRORMESSAGE." + preRes.data.error.code) ===
                "ERRORMESSAGE." + preRes.data.error.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + preRes.data.error.code);
              console.log(
                "导出Excel预下载执行失败, code:" + preRes.code,
                preRes.message
              );
            }
          } else {
            this.confirmFlag = true;
            this.confirmMsg = this.$t("ERRORMESSAGE.500");
            console.log("导出Excel预下载执行失败");
          }
        })
        .catch((error) => {
          this.orderloading = false;
          this.confirmFlag = true;
          this.confirmMsg = this.$t("ERRORMESSAGE." + error.mesCode);
          console.log("导出Excel预下载执行异常", error.objError);
        });
    },
    //选择客户
    selectClient(item) {
      this.searchForm.customerCode = item.customerCode;
      this.searchForm.customerName = item.customerName;
    },
    // 弹出客户姓名窗口方法
    showClientNamePop() {
      this.clientListFlag = true;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    setDestination(value) {
      this.searchForm.cityCode = value.cityCode;
      this.searchForm.city = value;
    },
    async getOrderData(detailParam) {
      this.orderloading = true;
      let that = this;

      await getIncidentList(detailParam)
        .then((res) => {
          if (res.code == 200) {
            that.tableData = [];
            if (res.data.error.code != 0) {
              that.confirmFlag = true;
              that.confirmMsg =
                that.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? that.$t("ERRORMESSAGE.NOTFOUND")
                  : that.$t("ERRORMESSAGE." + res.data.error.code);
              that.orderloading = false;
              that.totalCount = 0;
            } else {
              that.tableData = res.data.incidentList;
              that.totalCount = res.data.pagination.total;
              that.orderloading = false;
              that.searchForm.pageNum = 1;
            }
          } else {
            that.confirmFlag = true;
            that.confirmMsg =
              this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? that.$t("ERRORMESSAGE.NOTFOUND")
                : that.$t("ERRORMESSAGE." + res.code);
            console.log("getIncidentList, code:" + res.code, res.message);
          }
        })
        .catch(function (error) {
          that.confirmFlag = true;
          that.confirmMsg = that.$t("ERRORMESSAGE." + error.mesCode);
          that.orderloading = false;
          that.totalCount = 0;
          console.log("getIncidentList", error);
        });
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    searchClick() {
      this.Pageone = 1;
      var detailParam = {
        from: "HotelOrder",
        cityCode: this.searchForm.cityCode,
        bookingCode: this.searchForm.bookingCode.trim(),
        customerCode: this.searchForm.customerCode,
        hotelName: this.searchForm.hotelName,
        dateRange: {
          type: this.searchForm.dateTimeType,
          startDate: this.searchForm.dateTime
            ? formatDateTime(this.searchForm.dateTime[0], "YYYY-MM-DD")
            : null,
          endDate: this.searchForm.dateTime
            ? formatDateTime(this.searchForm.dateTime[1], "YYYY-MM-DD")
            : null,
        },
        bookingStatus:
          this.searchForm.orderStatus != ""
            ? this.searchForm.orderStatus.join()
            : "",
        paymentType:
          this.searchForm.paymentType != "0"
            ? this.searchForm.paymentType
            : null,
        guestName: this.searchForm.guestName,
        sourceBookingId: this.searchForm.sourceBookingId,
        hotelConfirmationNo: this.searchForm.hotelConfirmationNo,
        hotelType:
          this.searchForm.hotelType !== ""
            ? parseInt(this.searchForm.hotelType)
            : null, //枚举值：0：非协议，1：公司协议，2：CWT协议
        bookingChannel:
          this.searchForm.bookingChannel !== ""
            ? this.searchForm.bookingChannel.join()
            : null, //预定来源 多选(例如："1,2,3"); (枚举值: 0：APP，1：OBT，2：CRM代客下单，3：CRM补录订单，4：H5，6：ClientAPI)
        source:
          this.searchForm.source !== "" ? this.searchForm.source.join() : null, //供应商 多选格,式同预定来源 （枚举值：all：全部，sabre：Sabre，elong：ELong，fuxun：FuXun，dongcheng：东呈，huazhu：华住，atour：亚朵，rujia：如家）
        isInternational: this.searchForm.isInternational,
        countryCode: this.searchForm.countryCode,
        peopleType: this.searchForm.peopleType,
        mobile: this.searchForm.mobile,
        pageRequest: {
          pageNum: this.searchForm.pageNum,
          pageLimit: 15,
          total: 0,
        },
      };
      this.getOrderData(detailParam);
    },
    showMore() {
      this.showMoreDialog = !this.showMoreDialog;
    },
    //分页
    handleCurrentChange(pageNum) {
      this.searchForm.pageNum = pageNum;
      this.searchClick();
      this.Pageone = pageNum;
    },
    //获取搜索下拉值-国省市
    async getCountryList() {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: "",
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.nationoption = res.data.list;
            console.log("获取国家下拉值", res.data.list);
          } else {
            this.changeLoading = false;
          }
        })
        .catch(function (error) {
          console.log("获取国家下拉值 请求失败", error.objError);
        });
    },
  },
};
</script>
  
  <style scoped>
.pos_container_panel {
  padding-top: 10px;
}
::v-deep .el-input__icon {
  height: auto;
  width: 2.5rem;
  text-align: center;
  line-height: 0;
}
::v-deep .el-input__inner {
  height: 2.7rem;
  line-height: 2.7rem;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: 19px;
}
.myinput_inner /deep/ .el-input__inner {
  height: 2.7rem;
  border-radius: 0;
}
.div_grid {
  display: grid;
  grid-template-columns: 0.4fr 1fr;
  align-items: center;
}
.search-btn {
  background-color: #fc6640;
  color: #fff;
  border: 0px;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 0.3rem;
  font-family: Source-Sans-Bold;
}
::v-deep .el-dialog__header {
  padding: 0;
}
</style>
  